// extracted by mini-css-extract-plugin
module.exports = {"table":"InstalmentsDialog_table__MvDQ3","downloadButton":"InstalmentsDialog_downloadButton__S6mZT"};